import React from "react";
import Attorneys from "../../api/attorneys";

const Attorney = () => {
  return (
    <section className="team-section section-padding bg-light">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-8 text-center">
            <h2>Our Team</h2>
            <p>
              We gathered some of the most talented Company Secretaries, Cost
              Accountants, Lawyers, Strategic Planners, and Market & Business
              Planners. Our team has a sound knowledge of related issues and
              thrives in ideating, providing and implementing functional
              solutions.
            </p>
          </div>
        </div>

        <div className="row">
          {Attorneys.map((attorney, index) => (
            <div className="col-md-6 col-lg-3 mb-4" key={index}>
              <div className="card h-100 shadow-sm border-0 text-center">
                <img
                  src={attorney.AtImg}
                  alt={attorney.name}
                  className="card-img-top rounded-circle mx-auto mt-3"
                  style={{ width: "120px", height: "120px", objectFit: "cover" }}
                />

                <div className="card-body">
                  <h5 className="card-title fw-bold">{attorney.name}</h5>
                  <p className="card-text text-muted mb-2">{attorney.title}</p>

                  <div>
                    <a href={attorney.linkedin} className="btn btn-outline-secondary btn-sm me-2">
                      <i className="ti-linkedin"></i>
                    </a>
                    <a href={`mailto:${attorney.email}`} className="btn btn-outline-secondary btn-sm">
                      <i className="ti-email"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Attorney;
